import React from "react";
import { Box, Flex, Label } from "@catchoftheday/cg-components";
import { GenderPickerOption } from "./GenderPickerOption.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var GenderPicker = function GenderPicker(_ref) {
  var selected = _ref.selected,
      _onChange = _ref.onChange;
  return ___EmotionJSX(Box, null, ___EmotionJSX(Label, null, "Gender"), ___EmotionJSX(Flex, null, ___EmotionJSX(GenderPickerOption, {
    id: "gender-male",
    value: "m",
    checked: selected === "m",
    containerProps: {
      mr: 7
    },
    onChange: function onChange() {
      return _onChange("m");
    }
  }), ___EmotionJSX(GenderPickerOption, {
    id: "gender-female",
    value: "f",
    checked: selected === "f",
    onChange: function onChange() {
      return _onChange("f");
    }
  })));
};